import { render, staticRenderFns } from "./bankcardCheck.vue?vue&type=template&id=6f282983&scoped=true"
import script from "./bankcardCheck.vue?vue&type=script&lang=js"
export * from "./bankcardCheck.vue?vue&type=script&lang=js"
import style0 from "./bankcardCheck.vue?vue&type=style&index=0&id=6f282983&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f282983",
  null
  
)

export default component.exports